import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ConfigImportService } from '../../../../swaggerServices';

declare var $: any;

@Component({
    selector: 'app-atlas-import',
    templateUrl: './atlas-import.component.html',
    styleUrls: ['./atlas-import.component.scss'],
    standalone: false
})
export class AtlasImportComponent implements OnInit {
  @ViewChild('modal') modal: ElementRef;
  @ViewChild('configFileUpload') configFileUpload: ElementRef;

  configFile: Array<File>;
  modalMessage: { success?: {message?: any}, error?: {message?: string} };
  isLoading = false;


  constructor(
    private configImportService: ConfigImportService) {
   }

  ngOnInit() {
  }

  // validates for csv file format
  initFile(files: any) {
    this.configFile = [];
    if (files.length > 4) {
      this.modalMessage = {
        error: {
          message: "Cannot upload more than 4 files"
        }
      };
      $(this.modal.nativeElement).modal('show');
    }

    const pattern = (/\.(csv)$/i);
    var isValidType = [];
    for (var i=0; i<files.length; i++) {
      isValidType.push(pattern.test(files[i].name))
    }
    const hasWrongType = isValidType.find(i => i === false)
    if (hasWrongType !== undefined) {
      this.modalMessage = {
        error: {
          message: "Please ensure all uploaded files are in .csv format"
        }
      };
      $(this.modal.nativeElement).modal('show');
    } else {
      this.configFile = files;
    }
  }

  upload() {
    this.isLoading = true;
    //Upload up to 4 files
    let files = []
    for (var i =0; i < 4; i++) {
      if (i < this.configFile.length) {
        files.push(this.configFile[i])
      }else {
        files.push(undefined)
      }
    }

    this.configImportService.uploadAtlasFiles(files[0], files[1], files[2], files[3]).subscribe((r) => {
      this.isLoading = false;
      this.modalMessage = {
        success: {
          message: r
        } 
      };
      $(this.modal.nativeElement).modal('show');
      this.configFileUpload.nativeElement.value = '';
      this.configFile = undefined;
    }, (err) => {
      this.isLoading = false;
      let message
      if(Array.isArray(err.error)) { message = err.error; }
      else if (err.error && typeof err.error === 'object' && err.error !== null) { message = err.error.message; }

      this.modalMessage = {
        error: {
          message
        } 
      };
      $(this.modal.nativeElement).modal('show');
      this.configFileUpload.nativeElement.value = '';
      this.configFile = undefined;
    });
  }

}
